/* filepath: /Users/george/MatrizInc/MarketBrewer/Clients/street-lawyer-services/website/src/core/components/Header/DesktopNavigation.tsx */
import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const DesktopNavigation = () => {
  const menuItems = useMemo(
    () => [
      { name: "Home", path: "/" },
      { name: "Products", path: "/products" },
      { name: "Location", path: "/locations" },
      { name: "About", path: "/about" },
      { name: "Contact", path: "/contact" },
    ],
    []
  );

  const location = useLocation();

  return (
    <nav
      className="flex items-center"
      role="navigation"
      aria-label="Main navigation"
    >
      <ul className="flex space-x-8">
        {menuItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            (item.path !== "/" && location.pathname.startsWith(item.path));

          return (
            <li key={item.name} className="relative group">
              <Link
                to={item.path}
                className={`nav-link text-sm font-medium relative py-2 px-1 inline-block transition-colors duration-200 ${
                  isActive
                    ? "text-cannabis-green-300"
                    : "text-white hover:text-cannabis-green-300"
                }`}
                aria-current={isActive ? "page" : undefined}
              >
                {item.name}
                {/* Simple underline effect */}
                <span
                  className={`absolute bottom-0 left-0 w-full h-0.5 bg-cannabis-green-300 transform origin-left transition-transform duration-200 ease-out ${
                    isActive
                      ? "scale-x-100"
                      : "scale-x-0 group-hover:scale-x-100"
                  }`}
                ></span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default React.memo(DesktopNavigation);
